import { Routes } from '@angular/router';
import { TitleResolver } from '../resolver/metatitles/metatitles.resolver';
import { NotesComponent } from '../../pages/notes/notes.component';
import { RoleAccountGuard } from '../../guards/role-account.guard';
import { InboxComponent } from '../../pages/myinbox/myinbox.component';
import { PrivateNotesComponent } from '../../pages/private_notes/private-notes.component';

export const notesRoutes: Routes = [

/*   {
    path: 'notes',
    component: NotesComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.notes', role: ['Admin', 'Supervisor', 'Agent', 'Logistics', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'notes/:reference',
    component: NotesComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.notes', role: ['Admin', 'Supervisor', 'Agent', 'Logistics', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },  */
  {
    path: 'private-inbox',
    component: PrivateNotesComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.private-inbox', role: ['Admin', 'Supervisor', 'Agent', 'Logistics', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'private-inbox/:reference',
    component: PrivateNotesComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.private-inbox', role: ['Admin', 'Supervisor', 'Agent', 'Logistics', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },{
    path: 'inbox/my',
    component: InboxComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.inbox', role: ['Admin', 'Supervisor', 'Agent', 'Logistics', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'inbox/my/:reference',
    component: InboxComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.inbox', role: ['Admin', 'Supervisor', 'Agent', 'Logistics', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },

    {
    path: 'inbox',
    component: NotesComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.notes', role: ['Admin', 'Supervisor', 'Agent', 'Logistics', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'inbox/:reference',
    component: NotesComponent,
    resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
    data: { title: 'titles-menu-pages.notes', role: ['Admin', 'Supervisor', 'Agent', 'Logistics', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
];


export function getFilteredNotesRoutes(accountType: string, role: string): Routes {
  return notesRoutes.filter(route => {
    const allowedRoles = route.data?.['role'];
    const allowedAccountTypes = route.data?.['account_type'];
    const roleAllowed = !allowedRoles || allowedRoles.includes(role);
    const accountTypeAllowed = !allowedAccountTypes || allowedAccountTypes.includes(accountType);
    return roleAllowed && accountTypeAllowed;
  });
}
